import { useEffect, useState } from "react";

export type TypingTextProps = {
    text: string;
    delay?: number;
    chunkSizeRange?: [number, number];
    onDone?: () => void;
    isDisabledTyping?: boolean;
};

export const useTypingAnimation = ({
    text,
    delay = 30,
    chunkSizeRange = [10, 20],
    onDone,
    isDisabledTyping = false,
}: TypingTextProps): string[] => {
    const [chunks, setChunks] = useState<string[]>([]);
    const [isDone, setIsDone] = useState(false);
    const [minSize, maxSize] = chunkSizeRange;

    useEffect(() => {
        if (!text || isDisabledTyping) {
            setChunks([text]);
            setIsDone(true);
            return;
        }

        let currentIndex = 0;
        setChunks([]);
        setIsDone(false);

        const interval = setInterval(() => {
            const chunkSize = Math.floor(Math.random() * (maxSize - minSize + 1)) + minSize;
            const nextChunk = text.slice(currentIndex, currentIndex + chunkSize);
            currentIndex += chunkSize;

            setChunks((prev) => [...prev, nextChunk]);

            if (currentIndex >= text.length) {
                clearInterval(interval);
                setIsDone(true);
            }
        }, delay);

        return () => clearInterval(interval);
    }, [text, isDisabledTyping, delay, minSize, maxSize]);

    useEffect(() => {
        if (isDone && onDone) {
            onDone();
        }
    }, [isDone]);

    return chunks;
};
